import { Directive } from 'vue';

const OutsideClickDirective: Directive = {
   mounted(el, binding) {
      el.mousedownOutsideEvent = function (event: Event) {
         if (!(el === event.target || el.contains(event.target))) {
            binding.value(event, el);
         }
      };
      document.body.addEventListener('mousedown', el.mousedownOutsideEvent);
   },
   unmounted(el) {
      document.body.removeEventListener('mousedown', el.mousedownOutsideEvent);
   },
};

export { OutsideClickDirective };